import { ActionTree, GetterTree, MutationTree } from "vuex";
import { State } from "@/typings/store";

export interface StateVistaCargando {
  cargando: boolean;
}

const state: StateVistaCargando = {
  cargando: false,
};

const getters: GetterTree<StateVistaCargando, State> = {
  get(state): boolean {
    return state.cargando;
  },
};

const mutations: MutationTree<StateVistaCargando> = {
  set(state, data: boolean) {
    state.cargando = data;
  },
};

const actions: ActionTree<StateVistaCargando, State> = {
  set(ctx, data: boolean) {
    ctx.commit("set", data);
  },
};

const vistaCargando = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default vistaCargando;
